import { render, staticRenderFns } from "./op-detail.vue?vue&type=template&id=eafa096a&scoped=true"
import script from "./op-detail.vue?vue&type=script&lang=js"
export * from "./op-detail.vue?vue&type=script&lang=js"
import style0 from "./op-detail.vue?vue&type=style&index=0&id=eafa096a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eafa096a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eafa096a')) {
      api.createRecord('eafa096a', component.options)
    } else {
      api.reload('eafa096a', component.options)
    }
    module.hot.accept("./op-detail.vue?vue&type=template&id=eafa096a&scoped=true", function () {
      api.rerender('eafa096a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliance/invoiceManager/dialog/op-detail.vue"
export default component.exports